import script from "./TicketPresentationCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketPresentationCard.vue?vue&type=script&lang=ts&setup=true"

import "./TicketPresentationCard.vue?vue&type=style&index=0&id=4543b7d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4543b7d8"]])

export default __exports__